/** @format */

// REVIEW: page_category mapping is a proposal — adjust with analytics team as needed.

const PAGE_CATEGORY_RULES: { prefix: string; page_category: string }[] = [
  { prefix: '/administration', page_category: 'administration' },
  { prefix: '/knowledge-base', page_category: 'knowledge' },
  { prefix: '/personaldata', page_category: 'portfolio' },
  { prefix: '/dashboard', page_category: 'dashboard' },
  { prefix: '/extranet', page_category: 'extranet' },
  { prefix: '/profile', page_category: 'portfolio' },
  { prefix: '/access', page_category: 'portfolio' },
  { prefix: '/events', page_category: 'events' },
  { prefix: '/search', page_category: 'search' },
  { prefix: '/news', page_category: 'news' },
  { prefix: '/page/', page_category: 'legal' }
];

const PAGE_NAME_RULES: { pattern: RegExp; page_name: string }[] = [
  { pattern: /^\/dashboard\/[^/]+$/i, page_name: 'dashboard_detail' },
  { pattern: /^\/dashboard\/?$/i, page_name: 'dashboard' },
  { pattern: /^\/knowledge-base\/[^/]+\/article\/[^/]+$/i, page_name: 'knowledge_base_article' },
  { pattern: /^\/knowledge-base\/[^/]+$/i, page_name: 'knowledge_base' },
  { pattern: /^\/extranet\/content\/[^/]+\/edit\/[^/]+$/i, page_name: 'extranet_content_edit' },
  { pattern: /^\/extranet\/content\/[^/]+\/edit$/i, page_name: 'extranet_content_edit' },
  { pattern: /^\/extranet\/content\/[^/]+\/[^/]+$/i, page_name: 'extranet_content_detail' },
  { pattern: /^\/extranet\/content\/[^/]+$/i, page_name: 'extranet_content_detail' },
  { pattern: /^\/extranet\/[^/]+$/i, page_name: 'extranet_topic' },
  { pattern: /^\/extranet\/?$/i, page_name: 'extranet' },
  { pattern: /^\/search\/?$/i, page_name: 'search' },
  { pattern: /^\/news\/[^/]+$/i, page_name: 'news_detail' },
  { pattern: /^\/news\/?$/i, page_name: 'news' },
  { pattern: /^\/events\/?$/i, page_name: 'events' },
  { pattern: /^\/administration\/content\/create$/i, page_name: 'admin_content_create' },
  { pattern: /^\/administration\/content\/preview$/i, page_name: 'admin_content_preview' },
  { pattern: /^\/administration\/topics\/create$/i, page_name: 'admin_topic_create' },
  { pattern: /^\/administration\/topics$/i, page_name: 'admin_topics' },
  { pattern: /^\/administration\/tags$/i, page_name: 'admin_tags' },
  { pattern: /^\/administration\/?$/i, page_name: 'administration' },
  { pattern: /^\/profile\/?$/i, page_name: 'profile' },
  { pattern: /^\/personaldata\/?$/i, page_name: 'personal_data' },
  { pattern: /^\/access\/?$/i, page_name: 'access' },
  { pattern: /^\/page\/[^/]+\/[^/]+$/i, page_name: 'legal_page' },
  { pattern: /^\/page\/[^/]+$/i, page_name: 'legal_page' },
  { pattern: /^\/404\/?$/i, page_name: 'not_found' }
];

function normalizePathname(pathname?: string | null): string {
  if (!pathname || pathname === '/') {
    return '/';
  }
  return pathname.endsWith('/') && pathname.length > 1 ? pathname.slice(0, -1) : pathname;
}

export function resolveGa4PageCategory(pathname?: string | null): string {
  const normalized = normalizePathname(pathname);

  const match = PAGE_CATEGORY_RULES.find(rule => normalized.startsWith(rule.prefix));
  return match ? match.page_category : 'general';
}

export function resolveGa4PageName(pathname?: string | null): string {
  const normalized = normalizePathname(pathname);
  const matchedRule = PAGE_NAME_RULES.find(rule => rule.pattern.test(normalized));

  if (matchedRule) {
    return matchedRule.page_name;
  }

  const segments = normalized.split('/').filter(Boolean);
  if (segments.length === 0) {
    return 'home';
  }

  return segments.join('_');
}

export function getGa4PageContext(
  pathname?: string | null,
  _search = ''
): { page_name: string; page_category: string } {
  const normalized = normalizePathname(pathname);

  return {
    page_name: resolveGa4PageName(normalized),
    page_category: resolveGa4PageCategory(normalized)
  };
}
